import { Component, OnInit } from '@angular/core';
import { BannerService } from '@services/banner/banner.service';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  providers: [BannerService],
  standalone: false
})

export class BannerComponent implements OnInit {

  public title = 'Banners';

  public pageActions: PageAction[];
  public banners;

  constructor(public bannerService: BannerService, private router: Router, private dialogService: DialogService) {
  }

  async ngOnInit() {
    this.banners = (await this.bannerService.find(0, 100, {}))?.data;
    this.banners = this.banners.sort((b1, b2) => (b1?.order || 0) - (b2?.order || 0));
    this.pageActions = [new PageAction({ icon: 'add', title: 'Create Banner', callback: () => this.router.navigate(['banner/create']) })];
  }

  public edit(item, event: any): void {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    this.router.navigate(['banner', item._id, 'edit']);
  }

  async drop(event) {
    moveItemInArray(this.banners, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.banners.length; i++) {
      this.bannerService.patch(this.banners[i]._id, { order: i });
    }
  }

  public async remove(item: any, event: any) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    const res = await this.dialogService.confirm('Remove banner?');
    if (!res) {
      return;
    }
    this.bannerService.remove(item._id).then(() => {
      this.ngOnInit();
    }).catch(error => {
      const message = (error.error.message ? error.error.message : error.message);
      return this.dialogService.confirm(message, error.name);
    });
  }
}
